import React from "react";
import { Flame, HandHelping, Bell } from "lucide-react";

const MobileStickyCTA = () => (
  <div
    className="fixed bottom-0 left-0 right-0 z-30 md:hidden bg-[#050505]/92 backdrop-blur-xl border-t border-[#C9A44C]/20 px-3 py-3 grid grid-cols-3 gap-2"
    data-testid="mobile-sticky-cta"
  >
    <a href="#prayer" className="flex flex-col items-center justify-center gap-0.5 py-1.5 rounded-full border border-[#C9A44C]/30 text-[#F6F0E6] text-[11px] font-medium" data-testid="sticky-prayer">
      <Flame className="h-4 w-4 text-[#F28C18]" strokeWidth={1.5} />
      Prayer
    </a>
    <a href="#updates" className="flex flex-col items-center justify-center gap-0.5 py-1.5 rounded-full border border-[#C9A44C]/30 text-[#F6F0E6] text-[11px] font-medium" data-testid="sticky-updates">
      <Bell className="h-4 w-4 text-[#C9A44C]" strokeWidth={1.5} />
      Updates
    </a>
    <a href="#give" className="flex flex-col items-center justify-center gap-0.5 py-1.5 rounded-full text-[#0a0a0a] text-[11px] font-semibold" style={{ background: "linear-gradient(135deg,#E8C77A,#C9A44C 50%,#F28C18)" }} data-testid="sticky-give">
      <HandHelping className="h-4 w-4" strokeWidth={1.7} />
      Give
    </a>
  </div>
);

export default MobileStickyCTA;
